<div
	class="container-fluid p-0 container-login"
	style="background-image: url('assets/images/login/login_bg.webp') !important"
>
	<nav class="navbar custom-navbar">
		<div class="container-fluid d-flex align-items-center">
			<!-- Logo and Text -->
			<div class="d-flex align-items-start flex-column">
				<div class="d-flex align-items-center">
					<img
						class="img-fluid for-light m-r-10 navbar-logo"
						src="assets/images/logo/Tasyire-logo.png"
						alt="looginpage"
					/>
					<img
						class="img-fluid for-dark m-r-10 navbar-logo"
						src="assets/images/logo/Tasyire-logo.png"
						alt="looginpage"
					/>
				</div>
				<small class="text-muted mt-1 text-dark" translate>Manage everything, from anywhere.</small>
			</div>

			<!-- Signup Button -->
			<div class="ms-auto d-flex align-items-center">
				<span class="text-muted me-2 text-dark" translate>Don't have account?</span>
				<a [routerLink]="'../register'" class="btn custom-btn-primary" translate>Sign up</a>
			</div>
		</div>
	</nav>

	<div class="row">
		<div class="col-12">
			<div class="login-card">
				<div class="login-main">
					<h4 class="text-center fw-bold" translate>Sign in</h4>

					<div class="mt-3 text-center">
						<!-- Custom Button -->
						<!--						<button class="custom-btn custom-signin-btn" (click)="triggerGoogleSignIn()">-->
						<!--							<img src="assets/images/login/google.png" alt="Google Logo" class="google-icon" />-->
						<!--							<span translate>Continue with Google</span>-->
						<!--						</button>-->

						<!-- Hidden Google Sign-In Button -->
						<!--						<asl-google-signin-button class="hidden-google-signin" #googleSignIn>-->
						<!--						</asl-google-signin-button>-->

						<!--						<div class="separator mt-3">-->
						<!--							<hr class="line" />-->
						<!--							<span class="or-text" translate>OR</span>-->
						<!--							<hr class="line" />-->
						<!--						</div>-->
					</div>
					<form class="theme-form" [formGroup]="loginForm" (ngSubmit)="login()">
						<div class="form-group">
							<label class="col-form-label" translate>Username</label>
							<input
								class="form-control"
								type="text"
								required
								placeholder="{{ '@yourusername' | translate }}"
								formControlName="email"
							/>
							<div
								*ngIf="loginForm.controls.email.touched && loginForm.controls.email.errors?.required"
								class="text text-danger mt-1"
							>
								{{ 'Email is required' | translate }}
							</div>
						</div>
						<div class="form-group">
							<label class="col-form-label" translate>Password</label>
							<input
								class="form-control"
								[type]="show ? 'text' : 'password'"
								formControlName="password"
								required=""
								placeholder="*********"
							/>
							<div
								[ngClass]="[selectedLang.code === 'ar' ? 'hide-left' : 'hide-right']"
								(click)="showPassword()"
								*ngIf="!show"
							>
								<span class="show"></span>
							</div>
							<div
								[ngClass]="[selectedLang.code === 'ar' ? 'hide-left' : 'hide-right']"
								(click)="showPassword()"
								*ngIf="show"
							>
								<span class="Hide"></span>
							</div>
							<div
								*ngIf="
									loginForm.controls.password.touched && loginForm.controls.password.errors?.required
								"
								class="text text-danger mt-1"
							>
								{{ 'Password is required' | translate }}
							</div>
						</div>
						<div class="form-group mb-0">
							<div class="checkbox p-0">
								<div *ngIf="isError" class="text text-danger mt-1">
									{{ errorMessage | translate }}
								</div>
							</div>
							<div class="text-end mt-3">
								<button
									*ngIf="!isButtonDisabled"
									class="btn custom-btn-primary custom-btn"
									[disabled]="!loginForm.valid"
									type="submit"
								>
									<span>{{ 'Sign in' | translate }}</span>
								</button>
								<button
									*ngIf="isButtonDisabled"
									class="btn custom-btn-primary custom-btn"
									[disabled]="true"
									type="button"
								>
									<span>{{ 'Sign in' | translate }}</span>
								</button>
							</div>
							<p class="mt-2 mb-0 text-center" style="text-align: end">
								<a [routerLink]="'/auth/forgotpassword'" class="link" style="position: relative">{{
									'Forgot password ?' | translate
								}}</a>
							</p>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</div>
